import Vue from 'vue';
import DateInput from './components/DateInput.vue';

const dateInputs = Array.from(document.querySelectorAll('div[custom-field="dateInput"] input'));

dateInputs.forEach((dateInput) => {
    new Vue({
        el: dateInput,
        render: (h) => {
            return h(DateInput, {
                props: {
                    required: dateInput.required,
                    name: dateInput.name,
                    id: dateInput.id
                }
            });
        }
    });
});
